import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { insertNewLine } from '@/utils';
import Section from '../Section';
import Video from '../BrightcoveVideo';

const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
`;

const Description = styled.div`
  margin: 30px 0;
  white-space: pre-wrap;
`;

const MarkdownStyle = styled.div`
  > p {
    font-size: 16px;
  }
`;

const SectionHeader = ({ entryId, title, description, video }) => (
  <Section
    options={{
      outer: { style: { paddingBottom: 50, paddingTop: 50 } },
      inner: { locked: true },
      content: { locked: true },
    }}
    id={entryId}
  >
    {video && <Video {...video} />}
    <Title>{title}</Title>
    <Description>
      {insertNewLine({ key: 'video-section', description, component: MarkdownStyle })}
    </Description>
  </Section>
);

SectionHeader.defaultProps = {
  entryId: undefined,
  title: undefined,
  description: undefined,
  video: undefined,
};

SectionHeader.propTypes = {
  entryId: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  video: PropTypes.shape(),
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/Article/VideoSection.js